import React, { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./AgentTransfers.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import TextField from "@mui/material/TextField";

const fakeData = [
  {
    Date: "3/15/2023",
    Balance: 1000,
    Deposits: 1000,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/16/2023",
    Balance: 1500,
    Deposits: 500,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/17/2023",
    Balance: 1300,
    Deposits: 0,
    Withdrawal: 200,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/18/2023",
    Balance: 1200,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 100,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/19/2023",
    Balance: 1700,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 500,
    Fees: 0,
  },
  {
    Date: "3/20/2023",
    Balance: 1650,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 50,
  },
  {
    Date: "3/21/2023",
    Balance: 2150,
    Deposits: 500,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/22/2023",
    Balance: 1950,
    Deposits: 0,
    Withdrawal: 200,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/23/2023",
    Balance: 1900,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 50,
  },
  {
    Date: "3/24/2023",
    Balance: 2400,
    Deposits: 500,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/25/2023",
    Balance: 2300,
    Deposits: 0,
    Withdrawal: 100,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/26/2023",
    Balance: 2200,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 100,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/27/2023",
    Balance: 2700,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 500,
    Fees: 0,
  },
  {
    Date: "3/28/2023",
    Balance: 2650,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 50,
  },
  {
    Date: "3/29/2023",
    Balance: 3150,
    Deposits: 500,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "3/30/2023",
    Balance: 3100,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 50,
  },
  {
    Date: "3/31/2023",
    Balance: 3600,
    Deposits: 500,
    Withdrawal: 0,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "4/1/2023",
    Balance: 3400,
    Deposits: 0,
    Withdrawal: 200,
    Debits: 0,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "4/2/2023",
    Balance: 3300,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 100,
    Credits: 0,
    Fees: 0,
  },
  {
    Date: "4/3/2023",
    Balance: 3800,
    Deposits: 0,
    Withdrawal: 0,
    Debits: 0,
    Credits: 500,
    Fees: 0,
  },
];

export default function AgentTransaction({ tableData }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [selectedData, setSelectedData] = useState([]);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleClose = () => setOpen(false);

  const handleSort = (columnName) => {
    const isAsc = sorting.column === columnName && sorting.direction === "asc";
    setSorting({
      column: columnName,
      direction: isAsc ? "desc" : "asc",
    });
  };

  const sortedData = [...fakeData].sort((a, b) => {
    if (!sorting.column) return 0;

    let aValue = a[sorting.column];
    let bValue = b[sorting.column];

    if (sorting.column === "amount" || sorting.column === "amountDue") {
      aValue = Number(aValue.replace(/[^0-9.-]+/g, ""));
      bValue = Number(bValue.replace(/[^0-9.-]+/g, ""));
    }

    if (sorting.column === "date") {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    const isAsc = sorting.direction === "asc";
    if (aValue < bValue) {
      return isAsc ? -1 : 1;
    }
    if (aValue > bValue) {
      return isAsc ? 1 : -1;
    }
    return 0;
  });

  const pageCount = fakeData ? Math.ceil(fakeData.length / rowsPerPage) : 0;
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpen = (subAccounts) => {
    setOpen(true);
    setSelectedData([subAccounts]);
  };

  const resetDate = () => {
    setStartDate("");
    setEndDate("");
  };

  useEffect(() => {
    return () => {
      setSorting({
        column: "",
        direction: "asc",
      });
    };
  }, []);

  const sortedAndFilteredData = sortedData.filter((row) => {
    return row;
    return (
      (selectedStatus ? row.status === selectedStatus : true) &&
      (selectedType ? row.type === selectedType : true) &&
      row.recipient.toLowerCase().includes(search.toLowerCase())
    );
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.Date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    return (!start || itemDate >= start) && (!end || itemDate <= end);
  });

  return (
    <div className="agenttransfers-table">
      <div className="filter-container-transactions">
        <label class="selector-titles">Start Date</label>
        <TextField
          type="date"
          // label="Start Date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          sx={{ marginRight: 2 }}
        />

        <label class="selector-titles">End Date</label>
        <TextField
          type="date"
          //   label="End Date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <button onClick={resetDate}>Reset </button>
      </div>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Date")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Date</p>
                  {sorting.column === "Date" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Balance")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Balance</p>
                  {sorting.column === "Balance" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Deposits")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Deposits </p>
                  {sorting.column === "Deposits" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Withdrawal")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Withdrawal</p>
                  {sorting.column === "Withdrawal" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Debits")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Debits</p>
                  {sorting.column === "Debits" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Credits")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Credits</p>
                  {sorting.column === "Credits" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("Fees")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Fees</p>
                  {sorting.column === "Fees" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Date}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Balance}</p>
                    </TableCell>

                    <TableCell style={{ width: 200 }} align="left">
                      <div className="transaction-table-address-container">
                        <p className="transaction-table-date ">
                          {row.Deposits}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Withdrawal}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Debits}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Credits}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.Fees}</p>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </div>
  );
}
